module.exports = __webpack_public_path__ + "static/media/music.f5f1b3b4.svg";